import GraphQLClient from '../../core/adapter/graphQLClient';
import ProductCategory from '../../entity/productCategory';
import Session from '../../entity/session';
import unpaginatify from '../../utility/unpaginatify';
import getProductCategories from './query/getProductCategories';
import getProductCategory from './query/getProductCategory';

export type SearchParamType = {
  display?: boolean;
}

class ProductCategoryRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getProductCategories(session: Session, storeId: string, searchParams?: SearchParamType): Promise<ProductCategory[]> {
    return this.graphqlClient
      .query(session, getProductCategories, { variables: { storeId, searchInput: searchParams } })
      .then(({ data }: { data: any }) => unpaginatify(data['productCategoriesByStore']).map(item => ProductCategory.fromJson(item)));
  }

  public getProductCategory(session: Session, id: string): Promise<ProductCategory> {
    return this.graphqlClient
      .query(session, getProductCategory, { variables: { id } })
      .then(({ data }: { data: any }) => ProductCategory.fromJson(data['productCategoryByStore']));
  }
}

export default ProductCategoryRepository;
